import type { ReactElement } from 'react';
import type { BlockStatus } from './types';
import { MenuItem, MenuList, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { BlockStatusTag, BlockStatusTagProps } from './BlockStatusTag';

type StatusSelectorProps = {
  status: BlockStatus;
  availableStatuses: BlockStatus[];
  onStatusChange: (status: BlockStatus) => void;
} & BlockStatusTagProps;
export function StatusSelector({
  status,
  availableStatuses,
  onStatusChange,
  ...tagProps
}: StatusSelectorProps): ReactElement {
  if (availableStatuses.length === 1 && availableStatuses[0].id === status.id) {
    return <BlockStatusTag status={status} {...tagProps} />;
  }
  return (
    <PopoverRoot>
      <PopoverTrigger>
        <BlockStatusTag status={status} role="button" iconAfter="chevron-down" {...tagProps} />
      </PopoverTrigger>
      <PopoverPopup closeOnContentClick placement="bottom-start" offsetOptions={6}>
        <MenuList size="sm">
          {availableStatuses.map((s) => (
            <MenuItem
              lineHeight="1"
              key={s.id}
              label={<BlockStatusTag status={s} appearance="naked" />}
              active={s.id === status.id}
              onClick={() => onStatusChange(s)}
              disabled={s.id === status.id}
            />
          ))}
        </MenuList>
      </PopoverPopup>
    </PopoverRoot>
  );
}
